module.exports = __webpack_public_path__ + "static/img/华为-小艺.bdba65b7.png";